import script from "./VoucherForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./VoucherForm.vue?vue&type=script&lang=ts&setup=true"

import "./VoucherForm.vue?vue&type=style&index=0&id=1eab6977&lang=scss"

export default script